{
  "verified": "2026-09-13",
  "url": "https://www2.census.gov/programs-surveys/aies/data/2024/AIES00BASIC.zip",
  "sha256": "39c4235026672e7bffdbc36292ed976726df368f2ca435219aef1c84e8e4faa6",
  "rows": [
    {
      "code": "531",
      "label": "Real estate",
      "revenue": 682146688,
      "payroll": 120949436,
      "employees": 1815383,
      "revenueCV": 0.6,
      "employeesCV": 1.2,
      "line": 1590
    },
    {
      "code": "5412",
      "label": "Accounting, tax preparation, bookkeeping, and payroll services",
      "revenue": 246704121,
      "payroll": 100264109,
      "employees": 1487481,
      "revenueCV": 0.8,
      "employeesCV": 1,
      "line": 1650
    },
    {
      "code": "5413",
      "label": "Architectural, engineering, and related services",
      "revenue": 481449094,
      "payroll": 187743512,
      "employees": 1799846,
      "revenueCV": 0.8,
      "employeesCV": 0.8,
      "line": 1656
    },
    {
      "code": "5414",
      "label": "Specialized design services",
      "revenue": 39426414,
      "payroll": 9747327,
      "employees": 142201,
      "revenueCV": 3.6,
      "employeesCV": 3.8,
      "line": 1673
    },
    {
      "code": "5415",
      "label": "Computer systems design and related services",
      "revenue": 663500505,
      "payroll": 249634088,
      "employees": 2193738,
      "revenueCV": 0.7,
      "employeesCV": 0.7,
      "line": 1682
    },
    {
      "code": "5416",
      "label": "Management, scientific, and technical consulting services",
      "revenue": 463486454,
      "payroll": 173203986,
      "employees": 1862500,
      "revenueCV": 0.9,
      "employeesCV": 1.3,
      "line": 1688
    },
    {
      "code": "5417",
      "label": "Scientific research and development services",
      "revenue": 373946102,
      "payroll": 144993749,
      "employees": 1016712,
      "revenueCV": 1.7,
      "employeesCV": 1,
      "line": 1699
    },
    {
      "code": "5418",
      "label": "Advertising, public relations, and related services",
      "revenue": 149867658,
      "payroll": 44556456,
      "employees": 474764,
      "revenueCV": 1.3,
      "employeesCV": 1,
      "line": 1706
    },
    {
      "code": "5419",
      "label": "Other professional, scientific, and technical services",
      "revenue": 145495327,
      "payroll": 47680254,
      "employees": 795176,
      "revenueCV": 1.5,
      "employeesCV": 1.7,
      "line": 1723
    },
    {
      "code": "5613",
      "label": "Employment services",
      "revenue": 562087713,
      "payroll": 375208361,
      "employees": 6559328,
      "revenueCV": 1.2,
      "employeesCV": 1.4,
      "line": 1745
    },
    {
      "code": "5614",
      "label": "Business support services",
      "revenue": 91036868,
      "payroll": 31404326,
      "employees": 666815,
      "revenueCV": 1.1,
      "employeesCV": 0.8,
      "line": 1753
    },
    {
      "code": "5615",
      "label": "Travel arrangement and reservation services",
      "revenue": 91749957,
      "payroll": 19762481,
      "employees": 196265,
      "revenueCV": 0.9,
      "employeesCV": 1.4,
      "line": 1770
    },
    {
      "code": "5616",
      "label": "Investigation and security services",
      "revenue": 89607425,
      "payroll": 40296244,
      "employees": 1019173,
      "revenueCV": 1.1,
      "employeesCV": 1.2,
      "line": 1778
    }
  ]
}
